import { run } from '../../../update/run';

// 撤销
async function selectUpdateStackOut(stackOutItem: StackOutItem|null): Promise<void> {
    run(stackOutItem.data);
}

export {
    selectUpdateStackOut
};
